<div *ngIf="isOpen" class="modal-overlay" [class.transparent]="isTransparent" (click)="_onClose()">
  <ng-content></ng-content>
</div>
